import { useContext, useMemo } from "react";
import { ErrorUtils, IAxiosError } from "../../../utils";
import { AvisLoader } from "../components";
import { AvisContext } from "../context/AvisContext";

interface IErrorLoadingDataProps {
  error?: IAxiosError;
  loading?: boolean;
  children?: React.ReactNode;
  fullPageLoader?: boolean;
}

export function ErrorLoadingDataHoc(props: Readonly<IErrorLoadingDataProps>) {
  const { error, children, loading, fullPageLoader } = props;
  const { res } = useContext(AvisContext);

  const renderError = useMemo(() => {
    const errorCode = error?.errorCode;

    const messages = [
      res("error_FailedDataLoad"),
      ErrorUtils.getContactLaaErrorMessage(res, errorCode),
    ];

    return <div>{messages.join(" ")}</div>;
  }, [error, res]);

  if (error) {
    return renderError;
  }

  if (loading) {
    return <AvisLoader inline={!fullPageLoader} />;
  }

  return children;
}
